import Vue from 'vue'
import Vuex from 'vuex'

//挂载Vuex
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
     userInfo:'你好啊啊啊'
  },
  getters: {

  },
  mutations: {

  },
  actions: {

  }
})

export default store
